import React from 'react';
import { Outlet } from 'react-router-dom';
import NavigationAllCoupons from '../shared/layout/NavigationAllCoupons';

const AllCoupons = () => {
  return (
    <div>
      <NavigationAllCoupons />
      <Outlet />
    </div>
  );
};

export default AllCoupons;

